import { Box } from '@material-ui/core';

import { AbstractProgressWorkflow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/ProgressWorkflow/AbstractProgressWorkflow';
import { WorkflowStep } from '@/components/modules/CreditCard/Detail/Overview/components/Workflow/components/WorkflowStep';

export interface ProgressWorkflowProps {
  progress: AbstractProgressWorkflow;
}

export const ProgressWorkflow = ({ progress }: ProgressWorkflowProps) => {
  if (!progress?.isValid) {
    return null;
  }

  return (
    <Box minWidth={'100%'} marginY={'4px'} className="fade-vertical-wrapper">
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-start'}
        gridGap={8}
        maxHeight={'230px'}
        style={{ overflowY: 'scroll' }}
        minWidth={'100%'}
        paddingY={'10px'}
      >
        {progress.steps.map((step) => (
          <WorkflowStep key={step} step={step} workflow={progress.workflow} />
        ))}
      </Box>
    </Box>
  );
};
